// Edge calls for the person behind a row: their profile as the viewer may see it, reporting them
// or a group, and the picture upload. Same choke point and shape as friendsApi.ts.
import { CreateReportRequest, OkResponse, PersonProfile, UserProfile } from "@proef/contract";
import type { z } from "zod";
import { call } from "../edgeApi";

/** `GET /v1/users/:id/profile`: 404 for a person who cannot be shown, whatever the reason. */
export function getPersonProfile(userId: string): Promise<PersonProfile> {
  return call(PersonProfile, `/v1/users/${encodeURIComponent(userId)}/profile`);
}

/** `POST /v1/reports` answers `{ok:true}` whether or not the subject exists. */
export async function reportSubject(req: z.input<typeof CreateReportRequest>): Promise<void> {
  const body = CreateReportRequest.parse(req);
  await call(OkResponse, "/v1/reports", { method: "POST", body: JSON.stringify(body) });
}

/** `PUT /v1/account/avatar`: the raw image, with its own type as the content type. */
export function uploadAvatar(image: Blob): Promise<UserProfile> {
  return call(UserProfile, "/v1/account/avatar", {
    method: "PUT",
    body: image,
    headers: { "content-type": image.type },
  });
}

export type { PersonProfile } from "@proef/contract";
